/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file 
import { Action } from '@ngrx/store';

// send form to register user
export const GET_SPORTS = '[Get Sports] Get Sports';
export const GET_SPORTS_SUCCESS = '[Get Sports] Get Sports Success';
export const GET_SPORTS_FAIL = '[Get Sports] Get Sports Fail';

export class GetSports implements Action {
  readonly type = GET_SPORTS;

  constructor(public payload: any) {}
}

export class GetSportsSuccess implements Action {
  readonly type = GET_SPORTS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetSportsFail implements Action {
  readonly type = GET_SPORTS_FAIL;

  constructor(public payload: any) {}
}

// action types
export type SportsAction = GetSports | GetSportsSuccess | GetSportsFail;
